// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payments_login_page {
    width: 100%;
    height: 100%;
    min-height: calc(100vh - 100px);
    display: flex;
    justify-content: center;
    align-items: center;
}

.payments_login_form {
    width: 100%;
    max-width: 500px;
    padding: 20px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 3px 6px rgba(178, 178, 178, 0.16);
}


.main-container::-webkit-scrollbar {
    display: none;
}

.create_password_page {
    width: 100%;
    height: 100%;
    min-height: calc(100vh - 220px);
    display: flex;
    justify-content: center;
    align-items: center;
}

.create_password_page_container {
    min-width: 400px;
    padding: 20px;
    background-color: white;
    border-radius: 10px;
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
}

.create_password_page_container > h3 {
    text-align: center;
}

.code_input {
    width: 240px;
    border: 2px solid rgba(0, 190, 170, 1);
    height: 40px;
    outline: none;
    border-radius: 10px;
    margin-top: 20px;
    font-size: 20px;
    padding-left: 10px;
    letter-spacing: 12px;
}

.verification_form {
    background-color: #FFFFFF;
    border-radius: 5px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 40px;
}

.verification_form_content {
    width: 100%;
}

.verification_form_content > h1 {
    font-size: 18px;
    margin-bottom: 10px;
}

.verification_form_content > p {
    font-size: 14px;
    margin-bottom: 20px;
}

.verification_form_content_input > p {
    font-size: 12px;
    margin-bottom: 5px;
}

.verification_form_content_input > input {
    margin-top: 0;
    max-width: 250px;
}

.verification_form > div > img {
    max-width: 70%;
}

@media (max-width: 900px) {
    .verification_form {
        grid-template-columns: 1fr;
    }
    .verification_form > div:nth-child(2) {
        display: none;
    }
}

.weavr_passcode_container {
    padding: 40px;
    background-color: #FFFFFF;
    border-radius: 5px;
    width: 88%;
    max-width: 800px;
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.weavr_passcode_container > div {
    display: flex;
    justify-content: center;
    align-items: center;
}

.weavr_passcode_content {
    width: 100%;
}

.weavr_passcode_container > div > img {
    max-width: 60%;
}

#passcode {
    height: 40px;
    border: 1px solid rgba(14, 10, 64, 0.15);
    max-width: 250px;
    border-radius: 5px;
    margin-top: 3px;
    padding-top: 10px;
    padding-left: 5px;
}

.weavr_passcode_content > h1 {
    font-size: 18px;
    margin-bottom: 30px;
}

.weavr_passcode_input_box {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    min-width: 220px;
}

.weavr_passcode_btn {
    width: 100%;
    border-radius: 7px;
    height: 40px;
    border: 0;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    max-width: 250px;
    cursor: pointer;
    letter-spacing: 0.1px;
    background-color: #fd552b!important;
    color: #ffffff!important;
    font-size: 0.9rem;
}

.card_grid_2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.card_grid_3 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}

.card_form {
    width: 100%;
    max-width: 800px;
    position: relative!important;
}

.detail_view {
    display: grid;
    grid-template-columns: 2fr 1fr;
    width: 100%;
}

.card_detail_main {
    border-right: 1px solid #cecece;
    padding-right: 40px;
}

.card_detail_detail {
    padding: 0 20px;
}

.card_detail_buttons {
    display: flex;
    align-items: center;
    gap: 20px;
}

.card_chart_card {
    background-color: #FFFFFF;
    margin-top: 20px;
    padding: 15px;
    border-radius: 10px;
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    max-height: 420px;
}

.card_onboarding_info_page_container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    background-color: #FFFFFF;
    padding: 50px;
    margin-top: 60px;
    max-width: 88%;
    margin-left: auto;
    margin-right: auto;
}

.card_onboarding_info_page_card > h1 {
    font-size: 18px;
    margin-bottom: 20px;
}

.card_onboarding_info_page_card > p {
    font-size: 16px;
    line-height: 25px;
    margin-bottom: 40px;
}

.card_onboarding_info_page_container > div:nth-child(2) > img {
    max-width: 70%;
}

@media (max-width: 900px) {
    .card_onboarding_info_page {
        grid-template-columns: 1fr;
    }

    .card_onboarding_info_page > div:nth-child(2) {
        display: none;
    }
}

.weavr_login_container_content {
    width: 100%;
}

.weavr_login_container_content > h1 {
    font-size: 18px;
    margin-bottom: 20px;
}

.weavr_login_container_content > p {
    font-size: 14px;
    margin-bottom: 20px;
}

.kyb_box {
    background-color: #FFFFFF;
    width: 100%;
    padding: 40px;
    margin-top: 60px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: 88%;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
}

.kyb_box > div {
    display: flex;
    justify-content: center;
    align-items: center;
}

.kyb_box_content > h1 {
    font-size: 18px;
    margin-bottom: 20px;
}

.kyb_box_content > p {
    font-size: 16px;
    margin-bottom: 20px;
}

.kyb_box > div > img {
    max-width: 70%;
}

.payments_card_detail_header > h1 {
    color: #3D3D8E;
    font-size: 24px;
    font-weight: bold;
}

.payments_card_detail_header > h2 {
    color: #0D0A3D;
    font-size: 18px;
    font-weight: normal;
}

.payments_card_detail_top_section {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/payments/payments.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,+CAA+C;AACnD;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IAEnB,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,sCAAsC;IACtC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,mCAAmC;IACnC,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,+CAA+C;IAC/C,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,cAAc;AAClB","sourcesContent":[".payments_login_page {\n    width: 100%;\n    height: 100%;\n    min-height: calc(100vh - 100px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.payments_login_form {\n    width: 100%;\n    max-width: 500px;\n    padding: 20px;\n    background-color: white;\n    border-radius: 10px;\n    box-shadow: 0 3px 6px rgba(178, 178, 178, 0.16);\n}\n\n\n.main-container::-webkit-scrollbar {\n    display: none;\n}\n\n.create_password_page {\n    width: 100%;\n    height: 100%;\n    min-height: calc(100vh - 220px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.create_password_page_container {\n    min-width: 400px;\n    padding: 20px;\n    background-color: white;\n    border-radius: 10px;\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n}\n\n.create_password_page_container > h3 {\n    text-align: center;\n}\n\n.code_input {\n    width: 240px;\n    border: 2px solid rgba(0, 190, 170, 1);\n    height: 40px;\n    outline: none;\n    border-radius: 10px;\n    margin-top: 20px;\n    font-size: 20px;\n    padding-left: 10px;\n    letter-spacing: 12px;\n}\n\n.verification_form {\n    background-color: #FFFFFF;\n    border-radius: 5px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    padding: 40px;\n}\n\n.verification_form_content {\n    width: 100%;\n}\n\n.verification_form_content > h1 {\n    font-size: 18px;\n    margin-bottom: 10px;\n}\n\n.verification_form_content > p {\n    font-size: 14px;\n    margin-bottom: 20px;\n}\n\n.verification_form_content_input > p {\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n\n.verification_form_content_input > input {\n    margin-top: 0;\n    max-width: 250px;\n}\n\n.verification_form > div > img {\n    max-width: 70%;\n}\n\n@media (max-width: 900px) {\n    .verification_form {\n        grid-template-columns: 1fr;\n    }\n    .verification_form > div:nth-child(2) {\n        display: none;\n    }\n}\n\n.weavr_passcode_container {\n    padding: 40px;\n    background-color: #FFFFFF;\n    border-radius: 5px;\n    width: 88%;\n    max-width: 800px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n}\n\n.weavr_passcode_container > div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.weavr_passcode_content {\n    width: 100%;\n}\n\n.weavr_passcode_container > div > img {\n    max-width: 60%;\n}\n\n#passcode {\n    height: 40px;\n    border: 1px solid rgba(14, 10, 64, 0.15);\n    max-width: 250px;\n    border-radius: 5px;\n    margin-top: 3px;\n    padding-top: 10px;\n    padding-left: 5px;\n}\n\n.weavr_passcode_content > h1 {\n    font-size: 18px;\n    margin-bottom: 30px;\n}\n\n.weavr_passcode_input_box {\n    display: flex;\n    flex-direction: column;\n    font-size: 14px;\n    min-width: 220px;\n}\n\n.weavr_passcode_btn {\n    width: 100%;\n    border-radius: 7px;\n    height: 40px;\n    border: 0;\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 500;\n    max-width: 250px;\n    cursor: pointer;\n    letter-spacing: 0.1px;\n    background-color: #fd552b!important;\n    color: #ffffff!important;\n    font-size: 0.9rem;\n}\n\n.card_grid_2 {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n}\n\n.card_grid_3 {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n}\n\n.card_form {\n    width: 100%;\n    max-width: 800px;\n    position: relative!important;\n}\n\n.detail_view {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    width: 100%;\n}\n\n.card_detail_main {\n    border-right: 1px solid #cecece;\n    padding-right: 40px;\n}\n\n.card_detail_detail {\n    padding: 0 20px;\n}\n\n.card_detail_buttons {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.card_chart_card {\n    background-color: #FFFFFF;\n    margin-top: 20px;\n    padding: 15px;\n    border-radius: 10px;\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    max-height: 420px;\n}\n\n.card_onboarding_info_page_container {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    background-color: #FFFFFF;\n    padding: 50px;\n    margin-top: 60px;\n    max-width: 88%;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.card_onboarding_info_page_card > h1 {\n    font-size: 18px;\n    margin-bottom: 20px;\n}\n\n.card_onboarding_info_page_card > p {\n    font-size: 16px;\n    line-height: 25px;\n    margin-bottom: 40px;\n}\n\n.card_onboarding_info_page_container > div:nth-child(2) > img {\n    max-width: 70%;\n}\n\n@media (max-width: 900px) {\n    .card_onboarding_info_page {\n        grid-template-columns: 1fr;\n    }\n\n    .card_onboarding_info_page > div:nth-child(2) {\n        display: none;\n    }\n}\n\n.weavr_login_container_content {\n    width: 100%;\n}\n\n.weavr_login_container_content > h1 {\n    font-size: 18px;\n    margin-bottom: 20px;\n}\n\n.weavr_login_container_content > p {\n    font-size: 14px;\n    margin-bottom: 20px;\n}\n\n.kyb_box {\n    background-color: #FFFFFF;\n    width: 100%;\n    padding: 40px;\n    margin-top: 60px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    max-width: 88%;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 5px;\n}\n\n.kyb_box > div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.kyb_box_content > h1 {\n    font-size: 18px;\n    margin-bottom: 20px;\n}\n\n.kyb_box_content > p {\n    font-size: 16px;\n    margin-bottom: 20px;\n}\n\n.kyb_box > div > img {\n    max-width: 70%;\n}\n\n.payments_card_detail_header > h1 {\n    color: #3D3D8E;\n    font-size: 24px;\n    font-weight: bold;\n}\n\n.payments_card_detail_header > h2 {\n    color: #0D0A3D;\n    font-size: 18px;\n    font-weight: normal;\n}\n\n.payments_card_detail_top_section {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-gap: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
